import React from 'react';
import ModalComponent from '../../components/ModalComponent';
import Button from 'react-bootstrap/Button';
import { CLICK_ACTIONS } from '../../utils/Constant';

interface IAlertPopUpProps {
  title?: string;
  toggle: (action: string) => void;
  isOpen: boolean;
}

const AlertPopUP: React.FunctionComponent<IAlertPopUpProps> = ({
  title = 'Are you sure you want to remove?',
  toggle,
  isOpen,
}) => {
  const getChildren = () => (
    <div className="d-flex justify-content-center">
      <div className="preview-modal p-4">
        <div className="d-flex justify-content-center fw-bold mt-2">
          {title}
        </div>
        <div className="d-flex justify-content-between gap-2 mt-5">
          <Button
            variant="outline-primary"
            className="cl-btn-outline-primary w-50"
            onClick={() => {
              toggle(CLICK_ACTIONS.REJECT);
            }}
          >
            No
          </Button>
          <Button
            variant="primary"
            className="cl-btn-primary w-50"
            onClick={() => {
              toggle(CLICK_ACTIONS.APPROVE);
            }}
          >
            Yes
          </Button>
        </div>
      </div>
    </div>
  );
  return (
    <ModalComponent
      isOpen={isOpen}
      toggle={toggle}
      className="modalWrapper"
      backdrop={true}
    >
      {getChildren()}
    </ModalComponent>
  );
};
export default AlertPopUP;
